<template>
    <div class="wrap">
        <div class='earnings'>
            <div class="earningsTop">
                <div class="earningsicon">
                    <div style="display:flex;align-item:center;">
                        <img src="@/assets/images/floatball/icon.png" alt="">
                        <span :class="gold>=100000?'yellow':''">{{gold}}</span>
                    </div>
                    <p>今日已赚收益(金币)</p>
                </div>
                <p class="border"></p>
                <div class="earningsmin">
                    <div style="display:flex;align-item:center;">
                        <img src="@/assets/images/floatball/block.png" alt="">
                        <span>{{playtime}}</span>
                    </div>
                    <p>今日游玩时间(分钟)</p>
                </div>
            </div>
            <div class="earningsBottom" :style="withdraw == '100%'?'color:#A43F1B;':'color:#666666;'">
                <div class="gray"></div>
                <div class="orange" :style="{width:withdraw}"></div>
                <p v-if="!isgetmoney">
                    <span v-if="this.playtime>=5 || this.playtime=='60+'">今日提现任务已完成</span>
                    <span v-else>玩游戏5分钟立即提现0.3元</span>
                    <span v-if="this.playtime>=5 || this.playtime=='60+'" @click="toget">去提现<img class="right" src="@/assets/images/floatball/right.png" alt=""></span>
                    <span v-else>还差{{surplus}}分钟</span>
                </p>
                <p v-else class="finish">今日提现任务已完成，请明日再来</p>
            </div>
        </div>
         <p class="title">
            <img class="money1" src="@/assets/images/floatball/money.png" alt="">
            <span class="span1">更多赚钱任务</span>
            <img class="money2" src="@/assets/images/floatball/money.png" alt="">
        </p>
        <div class='mission'>
            <ul :style="{width:feilunwid}">
                <li v-for="(item,i) in feilundata" :key='i'>
                    <img :src="item.picture" alt="" @click="jump(item)">
                    <span>{{item.title}}</span>
                </li>
            </ul>
        </div>
        <p class="title">
            <img class="money1" src="@/assets/images/floatball/money.png" alt="">
            <span class="span2">奖励动态</span>
            <img class="money2" src="@/assets/images/floatball/money.png" alt="">
        </p>
        <div class='dynamicstate' v-if="goldRecord.length>0">
            <ul class="con">
                <li v-for="(item,ind) in goldRecord" :key='ind'>
                    <div class="conleft">
                        <p>{{item.type | getTitle}}</p>
                        <p>{{item.time | getStrTime}}</p>
                    </div>
                    <div class="conright"><span>{{item.amount>0?'+'+Number(item.amount).toFixed(0):item.amount==0?'+0':Number(item.amount).toFixed(0)}}</span>金币</div>
                </li>
            </ul>
        </div>
        <div class="dynamicstates" v-else>
            <img src="@/assets/images/floatball/iconnll.png" alt="">
            <p>
                今日还没游玩收益
                <br>
                赶紧游玩赚金币
            </p>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
export default {
    data(){
        return{
            withdraw:'0%',//判断是否可以提现
            gold: 0,//今日获取的金币数量
            feilundata: [],//飞轮的列表
            feilunwid:'',//飞轮内部的宽度
            goldRecord: [],//个人获取金币的动态数据展示
            playtime: 0,//玩游戏的时长
            surplus: 5,//提现的分钟数
            isgetmoney: false,//是否已经提现过了
        }
    },
    filters : {
      getTitle (type) {
          const map =  new Map([
            [ 0, '活动收益' ],
            [ 1, '游戏红包' ],
            [ 2, '新手任务' ],
            [ 3, '签到' ],
            [ 4, '每日任务' ],
            [ 5, '金币转化' ],
            [ 6, '游戏红包' ],
            [ 7, '提现' ],
            [ 8, '倒计时红包' ],
            [ 9, '排行榜收益' ],
            [ 10, '目标收益' ],
            [ 11, '新人红包' ],
            [ 12, '加成奖励' ],
            [ 13, '幸运红包' ],
            [ 14, '新人见面礼' ],
            [ 15, '收徒收益' ],
            [ 16, '唤醒收益' ],
            [ 17, '进贡收益' ],
            [ 18, '任务加成10%' ],
            [ 19, '补偿奖励' ],
            [ 20, '试玩收益' ],
            [ 21, '奖券瓜分奖励' ],
            [ 22, '刮刮乐奖励' ],
            [ 23, '刮刮乐额外奖金' ],
            [ 24, '口令奖励' ],
            [ 25, '邮件奖励' ],
            [ 26, '分享奖励' ],
            [ 27, '分享成功奖励' ],
            [ 28, '竞猜收益' ],
            [ 29, '试玩收益' ],
            [ 30, '游戏红包(翻倍)' ],
            [ 31, '充值返现' ],
            [ 32, '活动金币兑换' ],
            [ 33, '随机宝箱收益' ],
            [ 34, '悬赏任务收益' ],
            [ 35, '邀请挑战赛' ],
            [ 36, '玩游戏' ],
            [ 37, '日常广告任务收益' ],
            [ 38, '试玩收益' ],
            [ 39, '道具收益' ],
            [ 40, '比赛奖励' ],
            [ 41, '刮刮卡奖励' ],
            [ 42, '闲玩排行榜奖励' ],
            [ 43, '临时活动奖励' ],
            [ 44, '官方补偿' ],
            [ 45, '打卡报名' ],
            [ 46, '打卡奖励' ],
            [ 47, '打卡翻倍奖励' ],
            [ 48, '扩品类竞赛' ],
            [ 49, '分金库' ],
            [ 50, '新手摇数字' ],
            [ 51, '离线金币' ],
            [ 52, '离线金币' ],
            [ 53, '睡觉赚钱' ],
            [ 60, '走路赚钱' ],
            [ 61, '走路赚钱' ],
            [ 62, '推广奖励' ],
            [ 63, '兑换道具' ],
            [ 64, '游戏收益' ]
        ]);
          return map.get(type) || '活动收益';
      },
      getStrTime (time) {
          let date=new Date(time);
          return (date.getMonth()-1+2)+'-'+(date.getDate()>9?date.getDate():'0'+date.getDate())+' '+(date.getHours()>9?date.getHours():'0'+date.getHours())+':'+(date.getMinutes()>9?date.getMinutes():'0'+date.getMinutes());
      }
  },
    methods:{
        fetchData(userInfo){
            //金币的数量
            this.$http.get('/apiserv/backend/currency/getDailyGoldCount?uuid='+userInfo.uuid).then(res => {//+userInfo.uuid
                this.gold = res.data
            })
            //获取金币的动态
            this.$http.get('/logic/wallet/withdrawInfo?fields=gold,yesterdayGold,yesterdayDeposit,todayExchangeRate,goldRecord',{
                params:{
                    uuid:userInfo.uuid,
                    sessionId:userInfo.sessionId,
                    onlyId:userInfo.onlyId
                    // uuid:'2d4a95eef8a44375b4b89bc35591c4bc',
                    // sessionId:'59953469b2a6403380ba11b081c958ef',
                    // onlyId:'5d2581770fdd5300'
                    }
            }).then(res=>{
                this.goldRecord = res.data.goldRecord;
            })
        },
        //飞轮的数据
        getfeilun(appVersioncode,channelId,iosAndroid){
            let fd = new FormData();
            fd.append('appVersionCode', appVersioncode.split('.').join('')+'00');
            fd.append('channelId', channelId);
            fd.append('iosAndroid', iosAndroid);
            this.$http.post('/apiserv/api/gameserv/home/getNavigationList',fd,{
                headers: {
                    'Content-Type': 'form-data'
                }
            }).then(res => {
                if(res.data.return_code == 200){
                    this.feilundata = res.data.data;
                    if(window.innerWidth<640){
                        this.feilunwid = (this.feilundata.length)* 0.67 +0.09+ 'rem'
                    }else{
                        this.feilunwid = (this.feilundata.length)* 0.66 +0.16+ 'rem'
                    }
                }
            })
        },
        //跳转飞轮页面
        jump(item){
            collect('event_click_floatingball_jump',{
                skipAddress: item.skipAddress,
                skipType: item.skipType
            });
            if(item.skipAddress){
                Android.activeJump(item.skipType, item.skipAddress);
            }else{
                Android.activeJump(item.skipType, "")
            }
        },
        //跳转去体现页面
        toget(){
            collect('event_click_floatingball_getmoney');
            Android.jumpToWithDrawPageBy4399()
        },
    },
    mounted(){
        collect('event_click_floatingball_pageshow')
        let userInfo;
        if("Android" in window) {//android
            userInfo = JSON.parse(Android.getUserInfo());
            //获取金币
            this.fetchData(userInfo)
            //获取飞轮的列表
            var appVersionCode = Android.getAppVersionName()
            var channelId = Android.getAppChannel()
            this.getfeilun(appVersionCode,channelId,'a')

            this.$nextTick(() => {
                //获取玩游戏的时长
                var time = Math.floor(Android.getUserPlayGameTimeToday()/60/1000)
                this.playtime = time>60 ? '60+' : time;
                // console.log(this.playtime,'游戏时长')
                this.withdraw = time>=5 ? '100%' : (time/5).toFixed(2)*100 + '%' 
                if(time>=5){
                    collect('event_click_floatingball_showmoney');
                }
                //时间不够提现剩余的分钟数
                this.surplus = time>=5? 0 : (5-time)
                //展示的是提现完成的文字
                this.isgetmoney = Android.getWithDrawByLeyuan()
                // console.log(this.isgetmoney,'是否提现完成')
            })
        }
    }
}
</script>

<style lang="less" scoped>
@media(orientation:landscape){
    .wrap{
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        background: #FF570A;
        background-image: url('~@/assets/images/floatball/bgx.png');
        background-size: 100%;
        .earnings{
            width: 3.61rem;
            height: 1.05rem;
            margin-left: 0.07rem;
            margin-top: .07rem;
            background: #fff;
            border-radius: .13rem;
            .earningsTop{
                width: 3.42rem;
                display: flex;
                .earningsicon{
                    width: 0.71rem;
                    margin-left: 0.59rem;
                    img{
                        width: .19rem;
                        height: .2rem;
                        margin-left: 0.05rem;
                        margin-top:0.18rem;
                    }
                    span{
                        width: 0.39rem;
                        display: inline-block;
                        height: 0.19rem;
                        margin-left: .01rem;
                        margin-top: .16rem;
                        font-size: .16rem;
                        font-weight: bold;
                        color:rgba(255,80,0,1);
                    }
                    p{
                        width: .71rem;
                        margin-top: .07rem;
                        height:.12rem;
                        font-size:.08rem;
                        font-weight: bold;
                        color:rgba(51,51,51,1);
                        line-height:.12rem;;
                    }
                }
                .border{
                    width:0.01rem;
                    height:.28rem;
                    background:rgba(230,230,230,1);
                    margin-top:0.23rem;
                    margin-left:0.5rem;
                    margin-right:0.5rem;
                }
                .earningsmin{
                    width: 0.71rem;
                    img{
                        width: 0.18rem;
                        height: 0.18rem;
                        margin-left: 0.1rem;
                        margin-top:0.18rem;
                    }
                    span{
                        display: inline-block;
                        height: 0.19rem;
                        margin-left: .04rem;
                        margin-top: .17rem;
                        width:.29rem;
                        font-size:.16rem;
                        font-weight:bold;
                        color:rgba(255,80,0,1);
                        line-height:0.19rem;
                    }
                    p{
                        width:0.71rem;
                        height:0.12rem;
                        font-size:.08rem;
                        font-weight: bold;
                        color:rgba(51,51,51,1);
                        line-height:0.12rem;
                        margin-top: 0.08rem;
                    }
                }
            }
            .earningsBottom{
                width: 3.42rem;
                height: .26rem;
                border-radius: .06rem;
                margin-top: .14rem;
                position: relative;
                overflow: hidden;
                margin-left: 0.09rem;
                .gray{
                    width: 100%;
                    height: 100%;
                    background: #E9E9E9;
                    position:absolute;
                    left: 0;
                    top: 0;
                    z-index: 5;
                }
                .orange{
                    background:#FAD000;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    z-index: 10;
                }
                p{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 15;
                    line-height: .26rem;
                    span{
                        font-weight: 600;
                        font-size: .09rem;
                    }
                    span:nth-of-type(1){
                        float: left;
                        margin-left: .07rem;
                    }
                    span:nth-of-type(2){
                        float: right;
                        margin-right: .09rem;
                    }
                }
                .finish{
                    margin-left: .07rem;
                    font-weight: 540;
                }
            }
        }
        .title{
            width: 3.61rem;
            height: .16rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0.12rem 0.12rem 0.08rem;
            img{
                width: .07rem;
                height: .07rem;
            }
            .money1{
                margin-right: .05rem;
            }
            .money2{
                margin-left: .05rem;
            }
            .span1{
                display: inline-block;
                width:0.69rem;
                height:.16rem;
                font-size:.11rem;
                font-weight:bold;
                color:rgba(255,255,255,1);
                line-height:.16rem;
                text-shadow:0px 1px 1px rgba(230,72,0,1);
            }
            .span2{
                width:.46rem;
                height:.16rem;
                font-size:.11rem;
                font-weight:bold;
                color:rgba(255,255,255,1);
                line-height:.16rem;
                text-shadow:0px 1px 1px rgba(230,72,0,1);
            }
        }
        .mission{
            width: 3.61rem;
            height:.52rem;
            margin-left: .07rem;;
            border-radius: .07rem;
            background: #fff;
            overflow: hidden;
            overflow-x: scroll;
            padding: 0 0.16rem;
            ul{
                height: .52rem;
                box-sizing: border-box;
                white-space: nowrap;
                overflow-x: scroll;
                li{
                    width: .33rem;
                    height: 100%;
                    margin: 0 0.17rem 0 0.16rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    float: left;
                    img{
                        width: .19rem;
                        height: .19rem;
                        border-radius: .05rem;
                        margin-bottom: .04rem;
                    }
                    span{
                        font-size: .07rem;
                        color: #1B1B1B;
                        font-weight: 550;
                    }
                }
                li:nth-last-of-type(1){
                    margin-right: .16rem;
                }
            }
            
        }
        .dynamicstate{
            width: 3.61rem;
            height: 1.48rem;
            margin-left: 0.07rem;
            margin-bottom: 0.07rem;
            background: #fff;
            border-radius: .07rem;
            padding: 0 .07rem;
            overflow-y:scroll; 
            margin-bottom: .07rem;
            .con{
                width: 100%;
                overflow-y: scroll;
                margin: .03rem 0;
                li{
                    width: 100%;
                    height: .24rem;
                    margin: .06rem 0;
                    display: flex;
                    position: relative;
                    .conleft{
                        text-align: left;
                        p:nth-of-type(1){
                            height:0.12rem;
                            font-size:.08rem;
                            font-weight:550;
                            color:rgba(27,27,27,1);
                            line-height:0.12rem;
                        }
                        p:nth-of-type(2){
                            height:0.11rem;
                            font-size:.08rem;
                            font-weight:400;
                            color:rgba(153,153,153,1);
                            line-height:0.11rem;
                        }
                    }
                    .conright{
                         font-weight: 600;
                         color: #1B1B1B;
                         position: absolute;
                         right: .09rem;
                         top: 0;
                         font-size: .08rem;
                        span{
                            
                            font-weight:500;
                            color:rgba(255,80,0,1);
                            line-height:.12rem;
                        }
                    }
                }
            }
        }
        .dynamicstates{
            width: 3.61rem;
            height: 1.48rem;
            background: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-left: .07rem;
            border-radius: 0.07rem;
            margin-bottom: .07rem;
            img{
                width: .3rem;
                height: .3rem;
            }
            p{
                width:1.25rem;
                height:.26rem;
                font-size:.11rem;
                font-weight:600;
                color:rgba(204,204,204,1);
                line-height:.13rem;
                margin-top: 0.08rem;
                text-align: center;
            }
        }
    }
}

@media(orientation:portrait) {
    .wrap{
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: #FF570A;
        background-image: url('~@/assets/images/floatball/bgy.png');
        background-size: 100%;
        .earnings{
            width: 3.5rem;
            height: 1.87rem;
            margin-left: 0.12rem;
            margin-top: .1rem;
            background: #fff;
            border-radius: .13rem;
            .earningsTop{
                width: 3.5rem;
                display: flex;
                .earningsicon{
                    width: 1.27rem;
                    margin-left: 0.24rem;
                    img{
                        width: .29rem;
                        height: .29rem;
                        margin-left: 0.1rem;
                        margin-top:0.39rem;
                    }
                    span{
                        width: 0.69rem;
                        display: inline-block;
                        height: 0.33rem;
                        margin-left: .08rem;
                        margin-top: .31rem;
                        font-size: .29rem;
                        font-weight:bold;
                        color:rgba(255,80,0,1);
                    }
                    p{
                        width: 1.27rem;
                        margin-top: .16rem;
                        height:.21rem;
                        font-size:.14rem;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                        line-height:.21rem;;
                    }
                    .yellow{
                        margin-left: 0rem;
                    }
                }
                .border{
                    width:.01rem;
                    height:.5rem;
                    background:rgba(230,230,230,1);
                    margin-top:0.44rem;
                    margin-left:0.23rem;
                    margin-right:0.24rem;
                }
                .earningsmin{
                    width: 1.27rem;
                    img{
                        width: 0.29rem;
                        height: 0.28rem;
                        margin-left: 0.18rem;
                        margin-top:0.36rem;
                    }
                    span{
                        display: inline-block;
                        height: 0.33rem;
                        margin-left: .07rem;
                        margin-top: .34rem;
                        width:.52rem;
                        font-size:.29rem;
                        font-weight:bold;
                        color:rgba(255,80,0,1);
                        line-height:0.33rem;
                    }
                    p{
                        width:1.27rem;
                        height:0.21rem;
                        font-size:.14rem;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                        line-height:0.21rem;
                        margin-top: 0.17rem;
                    }
                }
            }
            .earningsBottom{
                width: 3.17rem;
                height: .45rem;
                border-radius: .06rem;
                margin-top: .25rem;
                position: relative;
                overflow: hidden;
                margin-left: 0.17rem;
                .gray{
                    width: 100%;
                    height: 100%;
                    background: #E9E9E9;
                    position:absolute;
                    left: 0;
                    top: 0;
                    z-index: 5;
                }
                .orange{
                    background: #FEEEA9;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    z-index: 10;
                }
                p{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 15;
                    line-height: .46rem;
                    span{
                        font-weight: 550;
                        font-size: .16rem;
                    }
                    span:nth-of-type(1){
                        float: left;
                        margin-left: .13rem;
                    }
                    span:nth-of-type(2){
                        float: right;
                        margin-right: .13rem;
                    }
                }
                .finish{
                    margin-left: .13rem;
                    font-weight: 550;
                }
                .right{
                    width: 0.07rem;
                    height: 0.14rem;
                    margin-left: .04rem;
                }
            }
        }
        .title{
            width: 3.5rem;
            height: .29rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0.21rem 0.12rem 0.15rem;
            img{
                width: .13rem;
                height: .13rem;
            }
            .money1{
                margin-right: .08rem;
            }
            .money2{
                margin-left: .08rem;
            }
            .span1{
                display: inline-block;
                width:1.23rem;
                height:.29rem;
                font-size:.2rem;
                font-weight:bold;
                color:rgba(255,255,255,1);
                line-height:.29rem;
                text-shadow:0px 1px 1px rgba(230,72,0,1);
            }
            .span2{
                width:.82rem;
                height:.29rem;
                font-size:.2rem;
                font-weight:bold;
                color:rgba(255,255,255,1);
                line-height:.29rem;
                text-shadow:0px 1px 1px rgba(230,72,0,1);
            }
        }
        .mission{
            width: 3.5rem;
            height:.92rem;
            margin-left: .12rem;;
            border-radius: .13rem;
            background: #fff;
            overflow: hidden;
            overflow-x: scroll;
            padding: 0 0.09rem;
            ul{
                height: .92rem;
                box-sizing: border-box;
                white-space: nowrap;
                overflow-x: scroll;
                li{
                    width: .58rem;
                    height: 100%;
                    margin: 0 0.05rem 0 0.04rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    float: left;
                    img{
                        width: .33rem;
                        height: .33rem;
                        border-radius: .08rem;
                        margin-bottom: .05rem;
                    }
                    span{
                        font-size: .13rem;
                        color: #1B1B1B;
                        font-weight: 500;
                    }
                }
                li:nth-last-of-type(1){
                    margin-right: .09rem;
                }
            }
            
        }
        .dynamicstate{
            width: 3.5rem;
            height: 2.63rem;
            margin-left: 0.12rem;
            background: #fff;
            border-radius: .13rem;
            padding: 0 .13rem;
            overflow-y:scroll; 
            .con{
                width: 100%;
                overflow-y: scroll;
                margin: .07rem 0;
                li{
                    width: 100%;
                    height: .42rem;
                    margin: .1rem 0;
                    display: flex;
                    position: relative;
                    .conleft{
                        text-align: left;
                        p:nth-of-type(1){
                            height:0.21rem;
                            font-size:.15rem;
                            font-weight:550;
                            color:rgba(27,27,27,1);
                            line-height:0.21rem;
                        }
                        p:nth-of-type(2){
                            height:0.19rem;
                            font-size:.14rem;
                            font-weight:400;
                            color:rgba(153,153,153,1);
                            line-height:0.19rem;
                        }
                    }
                    .conright{
                         font-weight: 600;
                         color: #1B1B1B;
                         position: absolute;
                         right: .05rem;
                         top: 0;
                        span{
                            font-weight:500;
                            color:rgba(255,80,0,1);
                            line-height:.21rem;
                        }
                    }
                }
            }
        }
        .dynamicstates{
            width: 3.5rem;
            height: 2.1rem;
            background: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-left: .12rem;;
            border-radius: .13rem;
            img{
                width: .5rem;
                height: .5rem;
            }
            p{
                width:1.25rem;
                height:.44rem;
                font-size:.15rem;
                font-weight:650;
                color:rgba(204,204,204,1);
                line-height:.22rem;
                margin-top: 0.08rem;
                text-align: center;
            }
        }
    }
}
    
</style>